import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ERoutes } from 'src/app/core/enums/routes.enum';

import { DynamicResolverService } from 'src/app/core/settings/resolvers/dynamic-resolver.service';

import { NewTripPlannerViewComponent } from './new-trip-planner.component';

const routes: Routes = [
  {
    path: ERoutes.EMPTY,
    component: NewTripPlannerViewComponent,
    resolve: {
      data: DynamicResolverService,
    },
    children: [
      {
        path: ':id',
        component: NewTripPlannerViewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewTripPlannerRoutingModule {}
